import { gql } from '@apollo/client';
export const EMPLOYEE_FIELDS = gql `
  fragment EmployeeFields on Employee {
    id
    createdAt
    updatedAt
    clientId
    userId
    uniqueId
    supervisorUniqueId
    hrMgrUniqueId
    deptMgrUniqueId
    hrVpUniqueId
    divVpUniqueId
    busPresUniqueId
    employmentType
    firstName
    lastName
    middleName
    jobCode
    jobTitle
    budgetCode
    budgetDesc
    locationCode
    locationDesc
    deptCode
    deptDesc
    level1Org
    level2Org
    level3Org
    category
    employmentStatus
    hoursPerWeek
    classification
    unionEmp
    unionType
    hireDate
    acquDate
    termDate
    address1
    address2
    city
    stateProvince
    zip
    countryCode
    email
    lockEmail
    phone
    phoneExt
    fax
    eligibility
    eligibilityDate
    eligibilityEndDate
    overrideElig
    overrideActive
    overrideDisb
    spendingCap
    calcCap
    custom1
    custom2
    custom3
    custom4
    custom5
    custom6
    custom7
    custom8
    custom9
    custom10
    custom11
    custom12
    custom13
    custom14
    custom15
    custom16
    custom17
    custom18
    custom19
    custom20
    customDate1
    customDate2
    customDate3
    customDate4
    customDate5
    customDate6
    customDate7
    customDate8
    customDate9
    customDate10
    customNumber1
    customNumber2
    customNumber3
    customNumber4
    customNumber5
    customNumber6
    customNumber7
    customNumber8
    customNumber9
    customNumber10
    empGroup
    roleNames
    signedUp
    productAccessSyncStatus
    productAccessSyncedAt
    guildUserUuid
  }
`;
export const EMPLOYEES = gql `
  ${EMPLOYEE_FIELDS}
  query EMPLOYEES($spec: EmployeeSpec!) {
    employees(spec: $spec) {
      total
      page
      pageSize
      items {
        ...EmployeeFields
      }
    }
  }
`;
export const SAVE_EMPLOYEE = gql `
  ${EMPLOYEE_FIELDS}
  mutation SAVE_EMPLOYEE($input: EmployeeInput!) {
    saveEmployee(input: $input) {
      ...EmployeeFields
    }
  }
`;
export const DELETE_EMPLOYEE = gql `
  ${EMPLOYEE_FIELDS}
  mutation DELETE_EMPLOYEE($id: Int!) {
    deleteEmployee(id: $id) {
      ...EmployeeFields
    }
  }
`;
export const SETUP_USER = gql `
  mutation SETUP_USER($input: SetupUserInput!) {
    setupUser(input: $input) {
      success
      messages {
        type
        value
        params
        sender
      }
    }
  }
`;
export const GET_EMPLOYEE = gql `
  ${EMPLOYEE_FIELDS}
  query GET_EMPLOYEE($id: Int!) {
    getEmployee(id: $id) {
      ...EmployeeFields
      client {
        id
        name
        code
      }
    }
  }
`;
export const CHECK_CORPORATE_ELIGIBILITY = gql `
  mutation CHECK_CORPORATE_ELIGIBILITY($input: CheckCorporateEligibilityInput!) {
    checkCorporateEligibility(input: $input) {
      success
      isEligible
      eligibilityDate
      messages {
        type
        value
        params
        sender
      }
    }
  }
`;
